export enum TaskCategories {
  Appointment = 'Appointment',
  AppointmentMissed = 'Appointment • Missed',
  ApptAsync = 'Appt • Async',
  ApptQueue = 'Appt • Queue',
  Async = 'Async',
  FrontDesk = 'Front desk',
  History = 'History',
  Messages = 'Messages',
  Onboarding = 'Onboarding',
  PostConsult = 'Post-consult',
  PreConsult = 'Pre-consult',
  Queue = 'Queue',
  Renewal = 'Renewal',
  // New replacement-order provider task (LMD-888). Value must match backend's
  // TASK_TYPES.REPLACEMENT exactly (packages/mongo-lifemd/src/task/constant.ts).
  Replacement = 'Replacement',
  RequestAppointment = 'Request • Appointment',
  Requests = 'Requests',
  RequestsOrder = 'Request • Order',
  RequestsPA = 'Requests • PA',
  Review = 'Review'
}
export enum QueueTaskStatuses {
  MIF_INCOMPLETE = 'MIF_INCOMPLETE',
  NO_PROVIDER_COVERAGE = 'NO_PROVIDER_COVERAGE',
  ONBOARDED = 'ONBOARDED',
  SC_COMPLETE = 'SC_COMPLETE',
  SC_INCOMPLETE = 'SC_INCOMPLETE',
  SC_SKIPPED = 'SC_SKIPPED',
  SC_URGENT = 'SC_URGENT',
  WITH_PROVIDER = 'WITH_PROVIDER'
}

export enum QueueTaskStatusLabels {
  MIF_INCOMPLETE = 'MIF incomplete',
  NO_PROVIDER_COVERAGE = 'No provider coverage',
  ONBOARDED = 'Onboarding marked complete by MA',
  SC_COMPLETE = 'Symptom checker complete',
  SC_INCOMPLETE = 'Symptom checker incomplete',
  SC_SKIPPED = 'Symptom checker skipped',
  SC_URGENT = 'Symptom checker urgent',
  WITH_PROVIDER = 'With provider'
}

export enum TaskTags {
  AIChat = 'ai-chat',
  AshOrderRejected = 'ash-order-rejected',
  ASQ = 'asq',
  AsyncCancelAccount = 'async-cancel-account',
  BookingFailed = 'booking-failed',
  CheckInFollowUp = 'check-in-follow-up',
  Documents = 'documents',
  FirstAppointment = 'first-appointment',
  LabResults = 'lab-results',
  LabTestReview = 'lab-test-review',
  MedicallyInsured = 'medically-insured',
  // Note: 'MH' in this enum means Mental Health (MHAsNeeded/MHDaily below), not Men's Health.
  MensHealth = 'mens-health',
  MHAsNeeded = 'mh-as-needed',
  MHDaily = 'mh-daily',
  Misc = 'miscellaneous',
  MonthlyMedicationCheckIn = 'monthly-medication-check-in',
  NewPatient = 'new-patient',
  NoSlotSelected = 'no-slot-selected',
  Nutrition = 'nutrition',
  PAReview = 'pa-review',
  PinkEye = 'pink-eye',
  PriorAuthorization = 'pa-required',
  Renewal = 'renewal',
  ReturningPatient = 'returning-patient',
  ShopPrescription = 'shop-prescription',
  Sleep = 'sleep-6s',
  SMS = 'sms',
  Social = 'social-6s',
  SteadyMD = 'steadymd',
  Stillness = 'stillness-6s',
  Stress = 'stress-6s',
  StuckScheduling = 'stuck-scheduling',
  Sweat = 'sweat-6s',
  Symptoms = 'symptoms',
  TripleTherapy = 'triple-therapy',
  UTI = 'uti',
  WHALaCarte = 'women-health-a-la-carte',
  WHEssentials = 'women-health-essentials',
  WHHrt = 'women-health-hrt',
  WHMedBundle = 'women-health-med-bundle',
  WM = 'weight-management'
}

export enum SymptomCheckerStatus {
  SC_COMPLETE = 'SC_COMPLETE',
  SC_INCOMPLETE = 'SC_INCOMPLETE',
  SC_SKIPPED = 'SC_SKIPPED',
  SC_URGENT = 'SC_URGENT'
}
